<template>
  <div>
    <BaseModal :name="name" width-class="tw-max-w-[550px]">
      <div>
        <div
          class="tw-flex tw-justify-center tw-rounded-t-xl tw-bg-error-500 tw-p-3"
        >
          <WarningIcon class="tw-h-6 tw-w-6 tw-text-white" />
        </div>
        <div class="tw-p-5 tw-text-center">
          <h2 class="tw-heading-2">
            {{
              isSubscriptionTrialInterval(SUBSCRIPTION_TRIAL_INTERVAL.ONCE)
                ? 'Trial Expired'
                : 'Sessions limit reached'
            }}
          </h2>

          <p class="tw-mt-3 tw-text-neutral-500">
            You will need to upgrade your membership in order to book any more
            calls.
          </p>

          <div
            class="tw-mt-4 tw-rounded-md tw-border tw-border-success-100 tw-bg-gradient-to-r tw-from-success-50 tw-via-white tw-to-white tw-p-6"
          >
            <div
              class="tw-text-xs tw-font-semibold tw-uppercase tw-text-success-500"
            >
              Membership upgrade
            </div>
            <div class="tw-mt-3 tw-text-lg">Upgrade your Membership</div>
            <p class="tw-text-sm tw-text-neutral-500">
              You may book paid calls or upgrade your plan to get 3 free calls
              in the queue at once.
            </p>
            <BaseButton
              color="outline-green"
              class="tw-mt-3 tw-uppercase"
              href="/upgrade_plan/new"
              is-inertia-link
            >
              Upgrade your plan
              <ExternalLinkIcon class="tw-ml-2 tw-h-4 tw-w-4" />
            </BaseButton>
          </div>

          <BaseButton
            color="outline-gray"
            @click="closeModal(name)"
            class="tw-mt-6"
          >
            Close
          </BaseButton>
        </div>
      </div>
    </BaseModal>
  </div>
</template>

<script setup>
import BaseButton from '../BaseButton.vue'
import WarningIcon from '@/assets/images/icons/warning.svg'
import ExternalLinkIcon from '@/assets/images/icons/external-link.svg'
import { useModals } from '@/shared/composables/useModals.js'
import BaseModal from '@/shared/components/BaseModal.vue'
import { usePermissionSystem } from '@/shared/composables/usePermissionSystem.js'
import { SUBSCRIPTION_TRIAL_INTERVAL } from '../../data/permissionSystem.js'

defineProps({
  name: {
    type: String,
    required: true,
  },
})

const { closeModal } = useModals()

const { isSubscriptionTrialInterval } = usePermissionSystem()
</script>
